import React from 'react';

// 1 = lunes … 7 = domingo (mismo convenio que el backend)
const WEEK_DAYS = [
  { value: 1, label: 'Lunes' },
  { value: 2, label: 'Martes' },
  { value: 3, label: 'Miércoles' },
  { value: 4, label: 'Jueves' },
  { value: 5, label: 'Viernes' },
  { value: 6, label: 'Sábado' },
  { value: 7, label: 'Domingo' }
];

const CalendarSettingsModal = ({
  open,
  onClose,
  alertVariant,
  status,
  config,
  setConfig,
  newCalendarId,
  setNewCalendarId,
  handleGoogleConnect,
  handleAddCalendarId,
  handleRemoveCalendarId,
  handleSaveCalendar
}) => {
  if (!open) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Google Calendar y agenda</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p className="text-muted">Conecta OAuth, añade calendarios y define horarios laborales.</p>
            {status && (
              <div className={`alert alert-${alertVariant(status.type)}`}>
                {status.message}
              </div>
            )}
            <form className="row g-2" onSubmit={handleSaveCalendar}>
              <div className="col-12">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="cal-enabled" checked={config.enabled} onChange={(e) => setConfig((p) => ({ ...p, enabled: e.target.checked }))} />
                  <label className="form-check-label" htmlFor="cal-enabled">Activar Google Calendar</label>
                </div>
                <div className="small text-muted">Estado OAuth: {config.connected ? 'Conectado' : 'No conectado'}</div>
                <button type="button" className="btn btn-outline-primary btn-sm mt-2" onClick={handleGoogleConnect}>Conectar con Google (OAuth)</button>
              </div>

              <div className="col-md-6">
                <label className="form-label">Calendar ID</label>
                <input className="form-control" value={config.calendarId} onChange={(e) => setConfig((p) => ({ ...p, calendarId: e.target.value }))} placeholder="ej: primary o tu@dominio.com" />
              </div>
              <div className="col-md-6">
                <label className="form-label">Zona horaria</label>
                <input className="form-control" value={config.workTimezone} onChange={(e) => setConfig((p) => ({ ...p, workTimezone: e.target.value }))} placeholder="Europe/Madrid" />
              </div>

              <div className="col-12">
                <label className="form-label">Calendarios adicionales</label>
                <div className="d-flex gap-2">
                  <input className="form-control" value={newCalendarId} onChange={(e) => setNewCalendarId(e.target.value)} placeholder="otro.calendario@dominio.com" />
                  <button className="btn btn-outline-secondary" type="button" onClick={handleAddCalendarId}>Añadir</button>
                </div>
                <div className="d-flex flex-wrap gap-2 mt-2">
                  {config.calendarIds.length === 0 ? (
                    <span className="text-muted small">No hay calendarios adicionales.</span>
                  ) : (
                    config.calendarIds.map((id) => (
                      <span key={id} className="badge bg-light text-dark border d-flex align-items-center gap-2">
                        <span>{id}</span>
                        <button type="button" className="btn btn-sm btn-link text-danger p-0" onClick={() => handleRemoveCalendarId(id)}>Quitar</button>
                      </span>
                    ))
                  )}
                </div>
                <div className="small text-muted">Se consultarán todos estos calendarios además del principal.</div>
              </div>

              <div className="col-12">
                <label className="form-label">Credenciales de servicio (JSON)</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder={config.hasCredentials ? 'Credenciales guardadas. Pega nuevas para actualizar.' : '{ "client_email": "", "private_key": "" }'}
                  value={config.credentials}
                  onChange={(e) => setConfig((p) => ({ ...p, credentials: e.target.value }))}
                />
                <div className="small text-muted">Se usa una cuenta de servicio; no se muestra la clave guardada por seguridad.</div>
              </div>

              <div className="col-12">
                <label className="form-label mb-1">Días laborables</label>
                <div className="d-flex flex-wrap gap-3">
                  {WEEK_DAYS.map((d) => {
                    const selected = Array.isArray(config.workDays) ? config.workDays : [1, 2, 3, 4, 5];
                    const checked = selected.includes(d.value);
                    return (
                      <div className="form-check" key={d.value}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`cal-day-${d.value}`}
                          checked={checked}
                          onChange={(e) => setConfig((p) => {
                            const current = Array.isArray(p.workDays) ? p.workDays : [1, 2, 3, 4, 5];
                            const next = e.target.checked
                              ? [...new Set([...current, d.value])].sort((a, b) => a - b)
                              : current.filter((v) => v !== d.value);
                            return { ...p, workDays: next };
                          })}
                        />
                        <label className="form-check-label" htmlFor={`cal-day-${d.value}`}>{d.label}</label>
                      </div>
                    );
                  })}
                </div>
                <div className="small text-muted">La IA (email y WhatsApp) solo propone llamadas y reuniones en estos días y dentro del horario de abajo.</div>
              </div>

              <div className="col-md-3">
                <label className="form-label">Mañana inicio</label>
                <input className="form-control" value={config.workMorningStart} onChange={(e) => setConfig((p) => ({ ...p, workMorningStart: e.target.value }))} />
              </div>
              <div className="col-md-3">
                <label className="form-label">Mañana fin</label>
                <input className="form-control" value={config.workMorningEnd} onChange={(e) => setConfig((p) => ({ ...p, workMorningEnd: e.target.value }))} />
              </div>
              <div className="col-md-3">
                <label className="form-label">Tarde inicio</label>
                <input className="form-control" value={config.workAfternoonStart} onChange={(e) => setConfig((p) => ({ ...p, workAfternoonStart: e.target.value }))} />
              </div>
              <div className="col-md-3">
                <label className="form-label">Tarde fin</label>
                <input className="form-control" value={config.workAfternoonEnd} onChange={(e) => setConfig((p) => ({ ...p, workAfternoonEnd: e.target.value }))} />
              </div>

              <div className="col-12">
                <button className="btn btn-primary" type="submit">Guardar calendario</button>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarSettingsModal;
